import { SET_UI_MANAGER_STATE, SET_MAP_TOOL, SET_PANEL } from './constants';
export const actionSetUIManagerState = (state) => ({
    type: SET_UI_MANAGER_STATE,
    payload: state,
});
export const actionSetPanel = (panel) => ({
    type: SET_PANEL,
    payload: panel,
});
export const actionSetMapTool = (mapTool) => ({
    type: SET_MAP_TOOL,
    payload: mapTool,
});
//# sourceMappingURL=actions.js.map